import PricingSection from "./ui/pricing-section";

const Pricing = () => {
  return <PricingSection />;
};

export default Pricing;
